import { AutocompleteInput, Grid } from '@kirz/mui-admin';
import React from 'react';

import { StepWrapper } from '../StepWrapper';

const options = [
  'Wettelijk stelsel',
  'Scheiding van goederen',
  'Gemeenschap van goederen',
];

export default function Step() {
  return (
    <StepWrapper
      name="Huwelijksstelsel"
      description="Selecteer hieronder je huwelijksstelsel (indien correct druk op 'volgende')"
    >
      <Grid container spacing={4}>
        <AutocompleteInput
          name="huwelijksstelsel"
          options={options.map((x) => ({
            text: x,
            value: x,
          }))}
          label="Selecteer"
          required
        />
      </Grid>
    </StepWrapper>
  );
}
